import AdminLayout from "Layout/Admin";

function AdminProfile() {
    return (<AdminLayout>
        Profile Page
    </AdminLayout>);
}

export default AdminProfile;